import React, { useEffect } from 'react'
import ExpandablePanel from '../controls/ExpandablePanel'
import CustomDatePicker from '../controls/CustomDatePicker'
import { formatDate, dateFromCalendar } from '../../lib/formatDateHandler'
import { controlHasError } from '../../lib/errorHandler'
import OkresSprawozdaniaStyle from '../../styles/OkresSprawozdaniaStyle'

function OkresSprawozdania(props) {
  useEffect(() => {
    if (!props.data.DataSporzadzenia && props.dataSporzadzenia)
      props.onSetSectionData('DataSporzadzenia', props.dataSporzadzenia)
  }, [])

  function onChangeDate(e, fieldName) {
    const newDate = dateFromCalendar(e)
    props.onSetSectionData(fieldName, newDate)
    if (fieldName === 'PoczatekOkresu')
      props.onSetDates(newDate, props.data.KoniecOkresu)
    else if (fieldName === 'KoniecOkresu')
      props.onSetDates(props.data.PoczatekOkresu, newDate)
  }

  return (
    <OkresSprawozdaniaStyle>
      <ExpandablePanel title="OKRES OBJĘTY SPRAWOZDANIEM FINANSOWYM I DATA SPORZĄDZENIA">
        <form autoComplete="off" className="okresSprawozdania">
          <div className="firstRow">
            <CustomDatePicker
              minDate={new Date(1995, 0, 1)}
              maxDate={new Date(2099, 11, 31)}
              error={controlHasError(props.errors, 'PoczatekOkresu')}
              name="PoczatekOkresu"
              label="Początek okresu"
              value={formatDate(props.data.PoczatekOkresu)}
              onChange={e => onChangeDate(e, 'PoczatekOkresu')}
            />
            <p className="separator">-</p>
            <CustomDatePicker
              minDate={new Date(1995, 0, 1)}
              maxDate={new Date(2099, 11, 31)}
              error={controlHasError(props.errors, 'KoniecOkresu')}
              name="KoniecOkresu"
              label="Koniec okresu"
              value={formatDate(props.data.KoniecOkresu)}
              onChange={e => onChangeDate(e, 'KoniecOkresu')}
            />
          </div>
          <div className="secondRow">
            <CustomDatePicker
              minDate={props.dataWersjiOd}
              maxDate={props.dataWersjiDo}
              error={controlHasError(props.errors, 'DataSporzadzenia')}
              name="DataSporzadzenia"
              label="Data sporządzenia"
              value={formatDate(props.data.DataSporzadzenia)}
              onChange={e => onChangeDate(e, 'DataSporzadzenia')}
            />
          </div>
        </form>
      </ExpandablePanel>
    </OkresSprawozdaniaStyle>
  )
}

export default OkresSprawozdania
